import { render } from "./ProfileAvatar.vue?vue&type=template&id=5bb25aa2"
import script from "./ProfileAvatar.vue?vue&type=script&lang=ts"
export * from "./ProfileAvatar.vue?vue&type=script&lang=ts"
script.render = render

export default script